import { render } from "./CxMetadataPanel.vue?vue&type=template&id=aeb69c98"
import script from "./CxMetadataPanel.vue?vue&type=script&lang=js"
export * from "./CxMetadataPanel.vue?vue&type=script&lang=js"

import "./CxMetadataPanel.vue?vue&type=style&index=0&id=aeb69c98&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__